// 学员考试记录
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, utils_tool, component_tool } from '@/tool'
import './index.less'

let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport, WizCard, WizRow, WizCol, WizTypography } = component_tool;
let { Session } = utils_tool
let { Text } = WizTypography
class ExaminationRecord extends WizContainer {
    componentName = 'examinationRecordList';

    constructor(props) {
        super(props);
        const { history } = props
        let subjectiveReviewRecord = {};
        if (history.location && history.location.pathname === '/online/subjectiveReview/record') {
            if (history.location && history.location.record) {
                subjectiveReviewRecord = history.location.record
                Session.set('subjectiveReviewRecord', subjectiveReviewRecord)
            } else {
                subjectiveReviewRecord = Session.get('subjectiveReviewRecord') || {}
            }
        }
        this.subjectiveReviewRecord = subjectiveReviewRecord
        this.state = {
            storageParams: {} // 用于存储当前请求的数据,页面刷新时用
        }
    }

    _componentDidMount() {
        this.bindVisibilityChange = this._handleVisibilitychange.bind(this)
        document.addEventListener('visibilitychange', this.bindVisibilityChange);
    }

    _componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.bindVisibilityChange);
    }

    propsAndStateOnChange = {
        recordInfo: this._recordInfoChange.bind(this),
    }

    _recordInfoChange(nextProps, nextState) {
        let { recordInfo } = nextProps
        let { success, msg, data } = recordInfo
        if (success) {
            let { current, size } = data
            // 保留请求信息,用于页面切换时请求的数据源
            nextState.storageParams = {
                current,
                size,
                examId: this.subjectiveReviewRecord.examId
            }
            return true
        }
        wizNotice.error(msg || '获取考试记录失败')
        return false
    }

    /**
     * 监听当前页隐藏显示
     * 显示时,更新下当前页
     */
    _handleVisibilitychange() {
        let isHidden = document.hidden;
        if (!isHidden) {
            let { storageParams } = this.state
            this.doAction({
                path: 'examinationRecord/listByPage',
                payload: {
                    key: 'examinationRecord@listByPage',
                    apiParams: {
                        ...storageParams
                    }
                },
            })
        }
    }

    _handleFile(nextProps, nextState, key) {
        let o = nextProps[key]
        let columnInitCfg = [
            {
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '姓名',
                field: 'fullName',
            },
            {
                headerName: '账号',
                field: 'userName',
            },
            {
                headerName: '组织名称',
                field: 'orgName',
            },
            {
                headerName: '组织编码',
                field: 'orgCode',
            },
            {
                headerName: '岗位',
                field: 'positionName',
            },
            {
                headerName: '考试开始时间',
                field: 'startDate',
            },
            {
                headerName: '考试结束时间',
                field: 'endDate',
            },
            {
                headerName: '状态',
                field: 'state',
            },
            {
                headerName: '批阅人',
                field: 'updateFullName',
            },
            {
                headerName: '批阅时间',
                field: 'updateTime',
            },
            {
                headerName: '当前批阅人',
                field: 'reviewFullName',
            }
        ]
        let exportColumns = columnInitCfg.map((e, i) => {
            if (i >= 1) {
                let colConfig = {
                    width: 20,
                    cellStyle: {
                        textAlign: 'center',
                    },
                    style: {
                        alignment: { vertical: 'bottom', horizontal: 'left' },
                    },
                }
                e = { ...e, ...colConfig }
            }
            return e
        })
        if (o['success']) {
            let data = o['data']
            let stateArrString = ['待批阅', '已批阅']
            data && data.forEach(d => {
                d.state = stateArrString[d.state]
            })
            WizBrowserExport({
                title: '学员考试记录',
                sheetName: '学员考试记录',
                columns: exportColumns.filter((_, index) => index),
                rows: data,
                filename: '学员考试记录.xlsx',
            })
            return true
        } else {
            wizNotice.error(o['msg'])
            return false;
        }
    }

    _renderHeadCardInfo() {
        let { examType, startDate, endDate, categoryType, title } = this.subjectiveReviewRecord
        let examTypeArrString = ['独立考试', '课程考试']
        return (
            <WizRow gutter={[15, 15]} type='flex' justify='space-around' className='head-style'>
                <WizCol span={10}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>考试名称：</span>
                        <span className='head-font-style'>{title}</span>
                    </Text>
                </WizCol>
                <WizCol span={10}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>考试分类：</span>
                        <span className='head-font-style'>{categoryType}</span>
                    </Text>
                </WizCol>
                <WizCol span={10}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>考试类型：</span>
                        <span className='head-font-style'>{examTypeArrString[examType]}</span>
                    </Text>
                </WizCol>
                <WizCol span={10}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>考试时间：</span>
                        <span className='head-font-style'>{`${startDate}~${endDate}`}</span>
                    </Text>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(),
            apiDataFormat: {
                export: this._handleFile,
            },
            examId: this.subjectiveReviewRecord.examId
        })
        return (
            <>
                <WizCard title='成绩概况'>
                    {this._renderHeadCardInfo()}
                </WizCard>
                <WizCard title='批阅'>
                    <WizReduxTemplate {..._reduxTemplateCofig} />
                </WizCard>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { examinationRecord } = state
    const recordInfo = modelUtils.getModelEntity(examinationRecord, 'examinationRecord@listByPage')
    return {
        recordInfo
    }
};

export default connect(mapStateToProps)(ExaminationRecord);
